/**
 * Centralized, type-safe access to environment variables.
 * Fail fast in development if anything is missing.
 */
const required = (key: string, value: string | undefined): string => {
  if (!value) {
    if (import.meta.env.DEV) {
      // biome-ignore lint/suspicious/noConsole: dev-only warning
      console.warn(`Missing required env var: ${key}`);
    }
    return '';
  }
  return value;
};

export const env = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL),
  supabaseAnonKey: required('VITE_SUPABASE_ANON_KEY', import.meta.env.VITE_SUPABASE_ANON_KEY),
  muxEnvKey: import.meta.env.VITE_MUX_ENV_KEY ?? '',
  stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '',
  posthogKey: import.meta.env.VITE_POSTHOG_KEY ?? '',
  posthogHost: import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  appUrl: import.meta.env.VITE_APP_URL ?? 'http://localhost:5173',
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY ?? '',
  isProd: import.meta.env.PROD,
} as const;
